module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hans/6-41bbfab0ff749be3ef4b83f71159b3ff.jpg";